module.exports = __webpack_public_path__ + "img/home2.48225c50.png";